export const blogClusters = [
  {
    id: 'chart-design',
    title: 'Make every chart clearer',
    description: 'Choose the right visual, remove clutter, and use color with intent.',
    hub: 'chart-design-checklist',
    slugs: ['chart-design-checklist', 'chart-colors-accessibility', 'right-chart-for-data', 'why-bar-charts'],
  },
  {
    id: 'data-storytelling',
    title: 'Find the story in the numbers',
    description: 'Turn a table into an honest takeaway, then write a title that earns it.',
    hub: 'data-storytelling-with-charts',
    slugs: ['data-storytelling-with-charts', 'chart-title-examples', 'stand-out-as-a-data-analyst', 'line-charts'],
  },
  {
    id: 'presentation-charts',
    title: 'Take your chart into the room',
    description: 'Build readable slides and export sharp images without losing context.',
    hub: 'charts-for-presentations',
    slugs: [
      'charts-for-presentations',
      'chart-export-resolution',
      'sales-data-visualization-guide',
      'marketing-data-visualization-guide',
    ],
  },
] as const;

export function getBlogCluster(slug: string) {
  return blogClusters.find(cluster => (cluster.slugs as readonly string[]).includes(slug));
}
